var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.19 63.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.84,41.27a1,1,0,0,0,.74-.33L34,28.31A1,1,0,1,0,32.49,27L21.1,39.6A1,1,0,0,0,21.17,41,1,1,0,0,0,21.84,41.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.85,33.08a3.31,3.31,0,1,0-3.34-3.31A3.33,3.33,0,0,0,23.85,33.08Zm0-4.62a1.31,1.31,0,1,1-1.34,1.31A1.33,1.33,0,0,1,23.85,28.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.56,41.09a3.31,3.31,0,1,0-3.34-3.31A3.33,3.33,0,0,0,31.56,41.09Zm0-4.62a1.31,1.31,0,1,1-1.34,1.31A1.33,1.33,0,0,1,31.56,36.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.57,47.87a5,5,0,0,0-6.9-2.08l-9.85,5.06A5,5,0,0,0,30,45H8.18a2.51,2.51,0,0,1-.39-.53c-.11-.17-2.57-4.21-.1-9.76,2.37-5.36,8.21-16.26,9.55-18.76l19.84-.12c1.43,2.68,7.84,14.79,9.53,19.34A25.79,25.79,0,0,1,48.07,43h2a27.83,27.83,0,0,0-1.58-8.54c-1.94-5.23-9.6-19.51-9.93-20.12a1,1,0,0,0-.12-.16l4.7-11.1a1,1,0,0,0-.14-1l-.7-.89a3,3,0,0,0-4-.68,4.64,4.64,0,0,1-4.63.17L33.58.6a5.14,5.14,0,0,0-5,.14,3,3,0,0,1-3.06,0,5.59,5.59,0,0,0-5.72.06L19.51,1a2.92,2.92,0,0,1-2.81.12l-1-.51a3.56,3.56,0,0,0-4.73,1.5,1,1,0,0,0,0,.86l4.82,11.58c-.52,1-7.25,13.45-9.87,19.36-2.91,6.57.11,11.44.22,11.6a4.34,4.34,0,0,0,.41.61L1.59,51H0v2H2a1,1,0,0,0,.71-.29L8.41,47H29.93a2.83,2.83,0,0,1,3,3,3,3,0,0,1-3.1,3H15a1,1,0,0,0,0,2H29.8A5.34,5.34,0,0,0,32,54.52h0l13.55-7a3,3,0,0,1,4.21,1.19,2.74,2.74,0,0,1-1.18,4L30.67,62H0v2H30.91a1,1,0,0,0,.46-.11l18.14-9.37A4.71,4.71,0,0,0,51.57,47.87ZM13,2.68a1.6,1.6,0,0,1,1.82-.31l1,.51a4.88,4.88,0,0,0,4.73-.21l.24-.15a3.6,3.6,0,0,1,3.68,0,5,5,0,0,0,5.1,0,3.13,3.13,0,0,1,3.08-.08l.13.07a6.63,6.63,0,0,0,6.63-.24,1,1,0,0,1,1.33.22l.34.43-4.65,11-18.77.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIco);
export default __webpack_public_path__ + "static/media/percent-ico.5b48aa9561703c963ddc36db90dc33bf.svg";
export { ForwardRef as ReactComponent };